import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "quiz-start-preamble-container"
};
const _hoisted_2 = {
  class: "quiz-start-title"
};
const _hoisted_3 = {
  class: "preamble-items-block"
};
const _hoisted_4 = {
  class: "preamble-item-label"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_quiz_readonly_alert = _resolveComponent("quiz-readonly-alert");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_icon, {
    icon: _ctx.icon,
    class: "quiz-start-icon"
  }, null, 8, ["icon"]), _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item,
      class: "preamble-item"
    }, [_createVNode(_component_icon, {
      icon: "checkbox-marked-circle-outline",
      class: "preamble-item-icon"
    }), _createElementVNode("span", _hoisted_4, _toDisplayString(item), 1)]);
  }), 128))]), _ctx.canEdit ? (_openBlock(), _createBlock(_component_quiz_readonly_alert, {
    key: 0,
    "is-speach-template": _ctx.isSpeachTemplate
  }, null, 8, ["is-speach-template"])) : _createCommentVNode("", true)]);
}